import LinkButton from "ds/components/Button/LinkButton";
import Callout from "ds/components/Callout";
import FeedbackActions from "ds/components/Feedback/Actions";
import useAnalytics from "hooks/useAnalytics";
import { AnalyticsPageOrganization } from "hooks/useAnalytics/pages/organization";
import useTypedContext from "hooks/useTypedContext";
import useCanManageApiKeys from "shared/ApiKey/access/useCanManageApiKeys";

import { SettingsContext } from "../../Context";
import { getManagementStrategy } from "../../helpers";
import { PERSONAL_API_KEYS_INFO_KEY } from "./constants";

const PersonalApiKeysInfoCallout = () => {
  const { activationStatus } = useTypedContext(SettingsContext);
  const canManageApiKeys = useCanManageApiKeys();

  const trackSegmentAnalyticsEvent = useAnalytics({
    page: AnalyticsPageOrganization.OrganizationApiKeys,
    defaultCallbackTrackProperties: { managementStrategy: getManagementStrategy(activationStatus) },
  });

  if (canManageApiKeys) {
    return (
      <Callout
        variant="info"
        title="Let your team create their own API keys"
        storageKey={PERSONAL_API_KEYS_INFO_KEY}
        closeCallback={() => trackSegmentAnalyticsEvent("Personal API Keys Callout Close")}
      >
        A personal API key belongs to one person and can never do more than they can. It stops
        working when they leave the organization, so keep organization API keys for CI and anything
        else that has to outlive its creator. You can turn personal API keys on or off in Settings.
        <FeedbackActions>
          <LinkButton
            to="/settings/api-keys/settings"
            analyticsPage={AnalyticsPageOrganization.OrganizationApiKeys}
            analyticsTitle="Personal API Keys Callout Click"
            variant="contrast"
            size="small"
          >
            Go to Settings
          </LinkButton>
        </FeedbackActions>
      </Callout>
    );
  }

  return (
    <Callout
      variant="info"
      title="Get an API key that belongs to you"
      storageKey={PERSONAL_API_KEYS_INFO_KEY}
      closeCallback={() => trackSegmentAnalyticsEvent("Personal API Keys Callout Close")}
    >
      A personal API key belongs to you and can never do more than you can. It stops working when
      you leave the organization, so keep organization API keys for CI and anything else that has to
      outlive you. If personal API keys aren’t turned on yet, ask an organization admin.
      <FeedbackActions>
        <LinkButton
          to="/personal-settings/api-keys"
          analyticsPage={AnalyticsPageOrganization.OrganizationApiKeys}
          analyticsTitle="Personal API Keys Callout Click"
          variant="contrast"
          size="small"
        >
          Go to personal API keys
        </LinkButton>
      </FeedbackActions>
    </Callout>
  );
};

export default PersonalApiKeysInfoCallout;
